import React from 'react'

import Format from 'helpers/Format'

export const textTooltip = (
  t: any,
  value: any,
  name: any,
  measurementUnitChart: string,
  nameKey: string
) => {
  if (measurementUnitChart == 'weight')
    return (
      <p className={'text-description'}>
        {name}
        <br />
        {t('day')} {Format(Number(value.time))}: {Format(Number(value[nameKey]).toFixed(2))}{' '}
        {t('weight_unity_kg').toLowerCase()}
      </p>
    )
  else if (measurementUnitChart === 'currency')
    return (
      <p className={'text-description'}>
        {name}
        <br />
        {t('day')} {Format(Number(value.time))}: {t('currency')}{' '}
        {Format(Number(value[nameKey]).toFixed(2))}
      </p>
    )
  return
}
